import type { ReactNode } from 'react'

import type { TCardProps } from '@/src/elements/card'
import { Placeholder, PlaceholderLine } from '@/src/elements/placeholder'
import { WatchmanThumbnail } from '@/src/elements/watchmanThumbnail/WatchmanThumbnail'
import { useAskWatchman } from '@/src/features/watchman/services/useAskWatchman'
import { TEST_ID } from '@/src/general/constants/testId'

import { IsNotWatchmanSection, type TIsNotWatchmanSectionProps } from './not-watchman/IsNotWatchmanSection'

export const WatchmanSection = ({ trackingSource, theme }: TCardProps & TIsNotWatchmanSectionProps): ReactNode => {
  const { isWatchman, isPending } = useAskWatchman()

  if (isPending) {
    return (
      <Placeholder testID={TEST_ID.WATCHMAN.LOADING} className="flex  h-16 flex-row items-center">
        <PlaceholderLine />
      </Placeholder>
    )
  }

  if (isWatchman) {
    return <WatchmanThumbnail />
  }

  return <IsNotWatchmanSection trackingSource={trackingSource} theme={theme} />
}
